export default __webpack_public_path__ + "static/media/1806.5e40428b.png";